import { useEffect } from "react";
import { loggerActions, socketActions } from "src/store/actions";
import { contentActions, userActions } from "src/store/slices";
import { useAppDispatch } from "./useAppDispatch";

export const useSubscribe = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const messageHandler = function (event: MessageEvent) {
      let data = event.data;

      if (typeof data === "string") {
        try {
          data = JSON.parse(data);
        } catch {
          dispatch(loggerActions.log("ОШИБКА ПАРСИНГА СООБЩЕНИЯ (postMessage)"));
        }
      }

      if (typeof data === "object" && data["accessToken"]) {
        dispatch(userActions.tokenUpdated(data["accessToken"]));
      }

      if (typeof data === "object" && "balanceId" in data) {
        dispatch(userActions.balanceIdUpdated(data["balanceId"]));
      }

      if (typeof data === "object" && "action" in data) {
        const action = data["action"];
        switch (action) {
          case "sound_muted": {
            const mute = data["mute"];
            if (mute == "1") {
              dispatch(contentActions.volumeUpdated(0));
            }
            if (mute == "0") {
              dispatch(contentActions.volumeUpdated(0.5));
            }
            break;
          }
        }
      }
    };

    const offlineHandler = function () {
      dispatch(socketActions.close());
    };

    window.addEventListener("message", messageHandler);
    window.addEventListener("offline", offlineHandler);

    window.top?.postMessage({ message: "liverace_init" }, "*");
    window.top?.postMessage("GAME_READY", "*");

    return () => {
      window.removeEventListener("message", messageHandler);
      window.removeEventListener("offline", offlineHandler);
    };
  }, [dispatch]);
};
